<template lang="pug">
  #find-new-friends
    BField
      BAutocomplete(
        size="is-large"
        rounded
        icon="magnify"
        :data="searchResults"
        placeholder="Search for new friends..."
        @typing="onSearch"
        :loading="searchingMembers"
        @select="select"
        openOnFocus
        :disabled="!friendsRequestingLoaded || !friendsInvitedLoaded"
      )
        template(slot-scope="props")
          .media
            .media-left
              EntityAvatar(:image="props.option.avatar" is-rounded)
            .media-content
              .content
                div(v-if="coreProgramMeta.showRealNames") {{ props.option.name }}
                div.mt-2
                  WtRouterLink(
                    to="ProfilePage"
                    :params="{ username: props.option.username }"
                    :text="'@'+props.option.username"
                  )
                div.mt-3
                  WtAddFriendButton(:member="props.option")
    .selected-friend(v-if="!_.isEmpty(selected)")
      .media
        .media-left
          EntityAvatar(:image="selected.avatar" is-rounded)
        .media-content
          .content
            div {{ selected.name }}
            div.mt-2
              WtRouterLink(
                to="ProfilePage"
                :params="{ username: selected.username }"
                :text="'@'+selected.username"
              )
            div.mt-3
              WtAddFriendButton(:member="selected")


</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import WtAddFriendButton from "@@/WtAddFriendButton/WtAddFriendButton";
import WtTitle from "@@/WtTitle/WtTitle";
import EntityAvatar from "@/components/WtEntityAvatar/WtEntityAvatar";

export default {
  name: "FindNewFriends",

  components: {
    EntityAvatar,
    WtAddFriendButton,
    WtRouterLink,
    WtTitle
  },

  data() {
    return {
      query: "",
      searchResults: [],
      searchingMembers: false,
      selected: {}
    };
  },

  computed: {
    ...mapGetters("members", [
      "friendsInvitedLoaded",
      "friendsRequestingLoaded"
    ]),
    ...mapGetters("program", ["coreProgramMeta"])
  },

  async created() {
    this.onSearch = this._.debounce(async query => {
      if (query[query.length - 1] === " ") {
        return;
      }
      if (query.length === 0) {
        return;
      }

      this.searchingMembers = true;
      this.searchResults = [];

      const response = await this.searchMembers({
        programId: this.$auth.user().programId,
        query: query,
        notFriends: 1
      });

      this.searchResults = response.data;
      this.searchingMembers = false;
    }, 500);
  },

  methods: {
    ...mapActions("program", ["searchMembers"]),

    select(option) {
      this.$emit("selected", option);
      this.selected = option;
    },

    onSearch() {
      // defined in created lifecycle hook
    },

    EntityAvatarOnError(event) {
      event.target.onerror = null;
      event.target.src = "https://cdn.tbybewell.com/images/default-avatar.png";
    }
  }
};
</script>

<style lang="sass">
#find-new-friends
  .autocomplete, .dropdown-content
    max-height: 300px !important
    .media-content
      +mobile
        overflow: hidden
  .dropdown-content
    width: 350px
  .autocomplete
    input.input
      font-size: 1rem
      min-height: 42px
      min-width: 350px
    .icon.is-left
      font-size: 1.1rem !important
  .selected-friend
    .media-content
      +mobile
        overflow: hidden
</style>
